@if (productData && statisticData?.length && chartData && !isLoading) {
  <app-charts [productData]="productData"
              [chartDataInput]="chartData"
              [statisticData]="statisticData"
              [isCustomData]="isCustomData"
              [sectionID]="sectionID()">
  </app-charts>
} @else if (tableData) {
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
      <tr>
        @if(tableData.header) {
          @for (cell of tableData.header; track cell) {
            <th style="font-weight: bold; background-color: var(--color-background-light);">
              <span [innerHTML]="cell"></span>
            </th>
          }
        }
      </tr>
      </thead>
      <tbody>
        @for (row of tableData.rows; track row; let rowIndex = $index) {
          <tr>
            @for (cell of row; track cell; let colIndex = $index) {
              <td>
                @if(colIndex === row.length - 1) {
                  @if(hasColoredCell(row)) {
                    <span [ngStyle]="{'color': 'var(--color-beige--dark)'}" [innerHTML]="cell"></span>
                    <span style="color: var(--color-beige--dark)">*</span>
                  } @else {
                    <span [ngStyle]="{'color': 'inherit'}" [innerHTML]="cell"></span>
                  }
                } @else {
                  <span [ngStyle]="{'color': shouldColorCell(row, colIndex) ? 'var(--color-beige--dark)' : 'inherit'}" [innerHTML]="cell"></span>
                  @if(shouldColorCell(row, colIndex)) {
                    <span style="color: var(--color-beige--dark)">*</span>
                  }
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>



} @else (){
  <div style="width: 100%; height: 280px; display: flex; justify-content: center; align-items: center;">
    <mat-spinner diameter="30" strokeWidth="2"></mat-spinner>
  </div>
}
